import { useState } from "react";
import PaymentInvoice from "./Invoice";
import { Form, Modal } from "react-bootstrap";

const GenerateInvoice = ({ show, onHide, bill }) => {
    const [checked, setChecked] = useState({
        kinya: true,
        english: false
    });
  return (
    <div>
      <Modal
        aria-labelledby='contained-modal-title-vcenter'
        centered
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>Generate Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f0f0fa" }}>
          <div className='d-flex justify-content-center mb-4'>
            <Form.Check
              type='radio'
              id='kinya'
              label='Kinyarwanda'
              name='language'
              checked={checked.kinya}
              onChange={() =>
                setChecked({
                  kinya: true,
                })
              }
            />
            <div>
              <Form.Check
                type='radio'
                label='English'
                id='english'
                className='ml-2'
                name='language'
                checked={checked.english}
                onChange={() =>
                  setChecked({
                    english: true,
                  })
                }
              />
            </div>
          </div>
          <PaymentInvoice
            language={checked}
            date={bill?.datetime}
            period={bill?.period}
            amount={bill?.amount}
            houseId={bill?.houseId}
            accountId={bill?.accountId}
            billId={bill?.id}
            billStatus={bill?.status}
            onHide={onHide}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default GenerateInvoice;
